export class TaikyoEntity {
    taikyoNo = 0;
    taikyoYmd = null;
    taikyoRiyuKb = 0;
    taikyoRiyuKbName = "";
    postCode = "";
    adr1 = "";
    adr2 = "";
    adr3 = "";
    addressAll = "";
    status = 0;
    tel = "";
    email = "";
    sonotaKeiyaku = "";
    keyReturnYmd = null;
    keyReturnStrYmd = "";
    keyReturnStrTime = "00:00";
    kaiyakuYmd = null;
    kaiyakuStrYmd = "";
    taikyoRiyu = "";
    henkinBankCd = null;
    henkinBansCd = null;
    henkinBankName = "";
    henkinBansName = "";
    henkinKouzaSb = 0;
    henkinKouzaNo = "";
    henkinKouzaKana = "";
    henkinKouzaName = "";
    needTachiai = false;
    isKeyreturnSoufu = false;
    hasParking = false;
    numberOfReturnKeys = null;
    taikyoTachiaiKb = null;
    taikyoTachiaiKbName = "";
    taikyoTachiaiName = "";
    keyReturnName = "";
    keyReturnNameKb = null;
    taikyoKanryoDate = null;
    movingServices = null;
    shinseiYmd = null;
    taikyoGuide = "";
}
